<!--
 * @Author: your name
 * @Date: 2019-06-18 15:00:31
 * @LastEditTime: 2019-11-25 15:03:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /d:\project\2019\07-website\02-code\webSiteHtml-onlineMap\source\src\components\onlineMap\POISearch\UCPOISuggestKey.vue
 -->
<!-- ucpoi建议词 -->
<template>
  <div class="div_ucPOISuggestKey">
    <ul>
      <li
        style="cursor:pointer"
        v-for="item in suggestPois"
        :key="item.id"
        @click="_poiItemClickHandler(item)"
      >
        <span v-show="item.name" class="suggest_item_name">{{item.name}}</span>
        <span v-show="item.address" class="suggest_item_address">{{item.address}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  POIResultItems,
  POISearchFilterType,
  POISearchFilter
} from "../model/POISearch.js";
import { UCPOISearchEvent } from "./UCPOISearchJs";

export default {
  name: "UCPOISuggestKey",
  data() {
    return {
      suggestPois: new Array(),

      curFilter: new POISearchFilter()
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    init() {
      let self = this;

      self.curFilter.filterType = POISearchFilterType.national_common_suggest;
      
      POIResultItems.search(
        self.curFilter,
        function(searchResult) {
          self.suggestPois = searchResult.objects;
        },
        function(error) {}
      );
    },


    //poi项单击事件
    off_poiItemClick(callback) {
      this.$off(UCPOISearchEvent.UCPOISuggestKey_poiItemClick, callback);
    },
    
    //poi项单击事件
    on_poiItemClick(callback) {
      this.$on(UCPOISearchEvent.UCPOISuggestKey_poiItemClick, callback);
    },

    _poiItemClickHandler(curPoi) {
      this.$emit(UCPOISearchEvent.UCPOISuggestKey_poiItemClick, curPoi);
    }
  }
};
</script>
<style <style lang="scss" scoped>
.div_ucPOISuggestKey {
  // position: absolute;
  background: #fff;
  // width: 100%;
  border: 1px solid #b8b8b8;
  // border-top: 0;
  // top: 35px;
  // left: -1px;

  .suggest_item_name
  {
    font-size: 14px;
    margin-left: 10px;
  }

  .suggest_item_address
  {
    font-size: 12px;
    color: #b8b8b8;
  }


}
</style>